import React from "react";
import successimage from "../../assets/Images/modalerrorimage.svg";
import { Box, Button, Modal } from "@mui/material";
import styles from "./NomineeDeclarationModal.module.scss";
import infoicon from "../../../Components/assets/Images/infoicon.svg";
import CloseIcon from "@mui/icons-material/Close";

const successModalStyles = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  borderRadius: "10px",
  boxShadow: 24,
  outline: "none",
  display: "flex",
};

interface props {
  openModal: boolean;
  handleClose: any;
  handleSubmit: any;
}

const NomineeDeclarationModal = ({
  openModal,
  handleClose,
  handleSubmit,
}: props) => {
  return (
    <Modal
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      open={openModal}
      slotProps={{
        backdrop: {
          timeout: 100,
        },
      }}
      BackdropProps={{
        style: {
          background: "rgba(31, 41, 55, 0.30)",
          backdropFilter: "blur(3px)",
          WebkitBackdropFilter: "blur(3px)",
        },
        timeout: 100,
      }}
    >
      <Box sx={successModalStyles}>
        <div className={styles.modalWrapper}>
          <div className={styles.title}>
            <span className={styles.titlespan}>Declaration</span>
            <div className={styles.closebutton} onClick={handleClose}>
              <CloseIcon />
            </div>
          </div>
          <p className={styles.desc}>
            I hereby declare that I do not wish to nominate any person for my
            trading and demat account at this time. I understand that I have the
            option to add a nominee at a later date
          </p>

          <div className={styles.cancelButtonsSection}>
            <div className={styles.infosection}>
              <img
                src={infoicon}
                // style={{
                //   filter: "grayscale(0.9) invert(0.9)",
                // }}
              />{" "}
              Keep your Aadhaar ready to proceed
            </div>
            <div className={styles.cancelButtonsSectionLeft}>
              <Button
                variant="outlined"
                onClick={handleClose}
                className={styles.cancel}
                style={{color:"var(--ds-text-primary)"}}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={handleSubmit}
                className={styles.submit}
              >
                Agree & E-Sign
              </Button>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default NomineeDeclarationModal;
